import buildZiegeApp from "./ziegeapp"

buildZiegeApp();
